export const moreProducts = {
  title: '更多产品',
  subtitle: '新译科技持续创新，更多 AI 翻译硬件即将发布',
  desc: '新译科技致力于打造全方位的 AI 翻译生态产品矩阵，除已发布的 MossTeams、MossTalk、MossVox 三大产品线外，更多创新产品正在研发中。',
  upcomingTitle: '即将推出',
  upcoming: [
    { icon: 'ri-glasses-line', name: 'AI 翻译眼镜', desc: '智能眼镜形态翻译设备，AR 实时字幕，解放双手，沉浸式跨语言沟通', eta: '预计 2026 Q4' },
    { icon: 'ri-device-line', name: '翻译平板', desc: '手上翻译助手，抬腕即译，支持 140+ 语种，商务出行与运动休闲两用', eta: '预计 2027 Q1' },
  ],
  features: [
    { icon: 'ri-customer-service-2-line', name: '定制需求', desc: '如果您有特定的翻译硬件需求，欢迎联系我们进行定制化产品研发' },
    { icon: 'ri-mail-send-line', name: '第一时间获取', desc: '订阅新闻简报，第一时间获取新译科技最新产品发布与行业资讯' },
  ],
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdj0',
};

export const supportData = {
  heroTitle: '服务支持',
  heroSubtitle: '全方位的技术支持和售后服务保障',
  heroDesc: '新译科技为所有产品提供 7×12 小时技术支持热线、2 年质保、免费固件升级及终身软件更新服务，确保您的设备始终处于最佳工作状态。',
  heroImageQuery: 'Newtranx technology customer support center with friendly service representatives helping clients, MossTeams MossTalk MossVox products displayed, technology help desk environment, warm ambient lighting, clean professional office setting, minimalist interior design, soft green and white color palette, corporate service atmosphere',
  heroImageSeq: 'support-hero',
  cards: [
    { icon: 'ri-phone-line', title: '技术热线', desc: '400-097-5066，工作日 9:00 - 21:00', href: 'tel:400-097-5066' },
    { icon: 'ri-mail-line', title: '邮件支持', desc: 'service02@newtranx.com，24小时内回复', href: 'mailto:service02@newtranx.com' },
    { icon: 'ri-file-download-line', title: '资源下载', desc: '产品手册、固件更新、白皮书', href: '/support/downloads' },
    { icon: 'ri-book-open-line', title: '知识库', desc: '常见问题、使用教程、故障排查', href: '/support' },
  ],
  warranty: {
    title: '质保政策',
    items: [
      { title: '硬件质保', desc: '所有硬件产品享 2 年免费质保，非人为损坏免费维修或换新。质保期后享受终身有偿维修服务。' },
      { title: '软件服务', desc: 'MossTalk APP 基础翻译功能永久免费，商务功能按需订阅。MossTeams 提供终身免费软件更新。' },
      { title: '固件升级', desc: '所有产品终身免费固件升级，持续优化性能和新增功能，通过 APP 一键更新。' },
    ],
  },
  faq: {
    title: '常见问题',
    items: [
      { q: 'MossTalk 翻译机如何连接手机？', a: '打开手机蓝牙，长按翻译机电源键 3 秒进入配对模式，在手机蓝牙设置中找到 "MossTalk Pro" 点击连接，然后打开 MossTalk APP 即可开始使用。' },
      { q: '翻译耳机支持哪些手机系统？', a: '支持 Android 8.0+ 和 iOS 13+ 系统。蓝牙 5.3 向下兼容，老旧设备也可正常使用。' },
      { q: 'MossTeams 双屏翻译机如何安装？', a: '开箱即用，接通电源后扫描屏幕二维码下载 APP，按指引完成设备绑定。无需复杂的网络配置，桌面摆放即插即用。' },
      { q: '录音牌的录音如何导出？', a: '通过 Type-C 数据线连接电脑，录音文件以 WAV 格式存储在设备中，直接拖拽复制。转写文本通过 MossVox APP 同步后在手机端查看和导出。' },
      { q: '离线翻译支持哪些语种？', a: 'MossTalk 标准款支持 10 种离线语种（中/英/日/韩/法/德/西/俄/阿/葡），商务款支持 15 种离线语种。MossTeams 离线翻译盒支持 14 种语种离线互译。' },
    ],
  },
  contactUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
};

export const casesData = {
  heroTitle: '客户案例',
  heroSubtitle: '服务全球 500+ 企业与机构，用 AI 翻译连接世界',
  heroDesc: '新译科技产品已广泛应用于国际会议、跨国企业、政府部门、教育机构等领域，累计服务超过 50 万用户。',
  heroImageQuery: 'Newtranx MossTeams dual screen translation device in action at successful international business conference, diverse professional team collaborating with AI translation technology, corporate case study scene, clean professional photography, warm natural lighting, confident collaborative atmosphere, minimalist modern meeting interior',
  heroImageSeq: 'cases-hero',
  cases: [],
};

export const downloadsData = {
  heroTitle: '资源下载',
  heroSubtitle: '产品资料、固件更新、白皮书一站式下载',
  heroDesc: '在此获取新译科技全系产品的最新固件、使用手册、白皮书及宣传资料。如需其他资源，请联系我们的技术支持团队。',
  heroImageQuery: 'Newtranx digital resource download center concept, organized file library showing MossTeams MossTalk MossVox product documentation PDFs firmware updates and white papers, floating interface with categorized downloadable resources for AI translation hardware, clean tech aesthetic, soft neutral color palette, modern cloud computing download atmosphere',
  heroImageSeq: 'downloads-hero',
  categories: [
    {
      title: 'MossTeams 会议系列',
      icon: 'ri-computer-line',
      items: [
        { name: 'MossTeams桌面端系统（macOS）-操作手册', size: '', type: '在线文档', desc: 'macOS电脑端同传与会议协作工具', url: 'https://i6uwrxclqm.feishu.cn/wiki/SKmXwk25UigsXXkBtOockHOpnid' },
        { name: 'MossTeams桌面端系统（Windows)-操作手册', size: '', type: '在线文档', desc: 'Windows电脑端同传与会议协作工具', url: 'https://i6uwrxclqm.feishu.cn/wiki/YwKbwrZRDi6m7zkxXUFc7TPsnVg'},
        { name: 'MossTeams智能会议双屏机—用户操作手册', size: '', type: '在线文档', desc: '专为高效会议场景打造的智能硬件设备', url: 'https://i6uwrxclqm.feishu.cn/wiki/KqOcwteZYiy9kvk5zyPcZEWdnqu' },
        { key: 'mossteams-client-win', icon: 'ri-windows-line', name: '桌面客户端安装包 (Windows)', size: '', type: 'EXE', desc: 'Windows 10/11 系统适配', url: 'https://newtranxdownload.newtranx.com/mossteams/MossTeams-win' },
        { key: 'mossteams-client-mac', icon: 'ri-apple-line', name: '桌面客户端安装包 (macOS)', size: '', type: 'DMG', desc: 'macOS 12+ 系统适配', url: 'https://newtranxdownload.newtranx.com/mossteams/MossTeams-mac' },
      ],
    },
    {
      title: 'MossTalk 翻译机系列',
      icon: 'ri-smartphone-line',
      items: [
        { key: 'mosstalk-standard-manual', icon: 'ri-file-text-line', name: '标准款产品手册', size: '', type: '在线文档', desc: '140+语种完整说明、APP使用指南', url: 'https://talk.newtranx.com/mosstalk/document'},
        { name: '商务款产品手册', size: '', type: '在线文档', desc: '商务功能详解、企业部署方案', url: 'https://talk.newtranx.com/mosstalk/document02' },
        { name: '翻译耳机产品手册', size: '', type: '在线文档', desc: '降噪技术说明、佩戴使用指南',url: 'https://talk.newtranx.com/mosstalk-earbuds/document' },

        // { name: 'MossTalk APP (Android)', size: '48 MB', type: 'APK', desc: '最新版本 v4.2.0' },
        // { name: 'MossTalk APP (iOS)', size: '—', type: 'App Store', desc: '前往 App Store 搜索 "MossTalk" 下载' },
        // { name: 'MossTalk 产品白皮书', size: '5.2 MB', type: 'PDF', desc: '产品对比、使用场景及行业方案' },
      ],
    },
    {
      title: 'MossVox 字幕系列',
      icon: 'ri-subtract-line',
      items: [
        { name: 'MossVox字幕精灵Pro用户使用手册', size: '', type: '在线文档', desc: '面向全球的一站式AI多媒体平台', url: 'https://i6uwrxclqm.feishu.cn/docx/Vxu3dIokPoiSc5xeaAhcpibEnob' },
        { name: 'MossVox字幕浏览器插件使用指南', size: '', type: '在线文档', desc: '支持Chrome/Edge/Safari主流浏览器', url: 'https://i6uwrxclqm.feishu.cn/docx/CQ6KdweiYo28M7xwl4FcL2RGnzd?from=from_copylink' },
        { key: 'mossvox-pro-win', icon: 'ri-windows-line', name: '字幕精灵 Pro 安装包 (Windows)', size: '', type: 'EXE', desc: 'Windows 10/11，支持Zoom/Teams/Meets', url: 'https://newtranxdownload.newtranx.com/mossvox/MossVox-Setup-win' },
        { key: 'mossvox-pro-mac', icon: 'ri-apple-line', name: '字幕精灵 Pro 安装包 (macOS)', size: '', type: 'DMG', desc: 'macOS 12+，支持所有会议平台', url: 'https://newtranxdownload.newtranx.com/mossvox/MossVox-Setup-mac' },
        { key: 'mossvox-plugin-chrome', icon: 'ri-chrome-line', name: '浏览器字幕插件chrome', size: '', type: 'ZIP', desc: '支持Chrome浏览器的字幕插件', url: 'https://newtranxdownload.newtranx.com/mossvox/MossVox-Plugin-chrome' },
        { name: '浏览器字幕插件edge', size: '', type: 'ZIP', desc: '支持Edge浏览器的字幕插件', url: 'https://newtranxdownload.newtranx.com/mossvox/MossVox-Plugin-edge' },
        { key: 'mossvox-recorder-manual', icon: 'ri-file-pdf-2-line', name: '录音牌产品手册', size: '', type: 'PDF', desc: '操作指南、转写参数说明', url: 'https://aihub-resource.newtranx.com/handbook/MossVox_zh.pdf' },
      ],
    },
    {
      title: '智译一体机',
      icon: 'ri-mac-fill',
      items: [
        { name: '智译一体机白皮书', size: '', type: 'PDF', desc: '小型团队 AI 离线翻译低预算理想之选', url: 'https://docstore.newtranx.com/minio-show/mossvox-website/newtranx-mossvox-2025-20260616111011.pdf' },
      ],
    },
  ],
};

export const contactData = {
  heroTitle: '联系我们',
  heroSubtitle: '我们期待与您沟通交流',
  heroDesc: '无论您是产品咨询、商务合作、技术支持还是媒体采访，请通过以下方式联系新译科技团队，我们将竭诚为您服务。',
  heroImageQuery: 'Newtranx technology',
  heroImageSeq: 'contact-hero',
  info: {
    phone: { label: '服务热线', value: '400-097-5066' },
    email: { label: '电子邮箱', value: 'service02@newtranx.com' },
    address: { label: '公司地址', value: '北京市通州区世界侨商中心2号楼17层' },
    hours: { label: '工作时间', value: '工作日 9:00 - 18:00' },
  },
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
  newsletterUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdj0',
};